import { render, staticRenderFns } from "./PlayersOutstanding.vue?vue&type=template&id=68ce0443&"
import script from "./PlayersOutstanding.vue?vue&type=script&lang=js&"
export * from "./PlayersOutstanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports